import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCompetition, startCompetition, putOverride, promoteConfig, getAllocationSourceSeries } from "./api";

export function useCompetition(scope = "insights") {
  return useQuery({
    queryKey: ["forecast-lab-competition", scope],
    queryFn: () => getCompetition(scope),
    refetchOnWindowFocus: false,
    refetchInterval: (data) => (data?.running ? 4000 : false),
  });
}

export function useStartCompetition() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: startCompetition,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["forecast-lab-competition"] }),
  });
}

export function useOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: putOverride,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["forecast-lab-competition"] }),
  });
}

export function usePromote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: promoteConfig,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["forecast-lab-competition"] }),
  });
}

export function useAllocationSourceSeries(sourceKey, horizon = 90, enabled = true) {
  return useQuery({
    queryKey: ["forecast-lab-alloc-source", sourceKey, horizon],
    queryFn: () => getAllocationSourceSeries(sourceKey, horizon),
    enabled: enabled && !!sourceKey,
  });
}
